import React from "react";
import { useColors } from "../context/ThemeContext";

const SHELL = { maxWidth: 430, margin: "0 auto", left: 0, right: 0 };

/**
 * In-app confirmation dialog (replaces window.confirm / alert).
 */
export default function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  destructive = false,
  busy = false,
  onConfirm,
  onCancel,
}) {
  const C = useColors();
  if (!open) return null;

  const confirmBg = destructive ? C.danger : C.lime;
  const confirmColor = destructive ? "#fff" : C.bg;

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="confirm-dialog-title"
      style={{
        position: "fixed",
        inset: 0,
        ...SHELL,
        background: "rgba(0,0,0,0.85)",
        zIndex: 4000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 24,
      }}
      onClick={() => { if (!busy) onCancel?.(); }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 380,
          background: C.surface,
          borderRadius: 24,
          padding: "28px 24px",
          border: `1px solid ${C.border}`,
          textAlign: "center",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          style={{
            width: 56,
            height: 56,
            borderRadius: "50%",
            background: (destructive ? C.danger : C.lime) + "18",
            border: `2px solid ${(destructive ? C.danger : C.lime)}30`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 16px",
            color: destructive ? C.danger : C.lime,
            fontSize: 22,
            fontWeight: 900,
          }}
        >
          !
        </div>
        <p
          id="confirm-dialog-title"
          style={{ color: C.text, fontSize: 17, fontWeight: 900, margin: "0 0 8px" }}
        >
          {title}
        </p>
        {message ? (
          <p style={{ color: C.muted, fontSize: 13, lineHeight: 1.6, margin: "0 0 24px" }}>
            {message}
          </p>
        ) : (
          <div style={{ height: 16 }} />
        )}
        <div style={{ display: "flex", gap: 10 }}>
          <button
            type="button"
            disabled={busy}
            onClick={onCancel}
            style={{
              flex: 1,
              padding: 14,
              borderRadius: 14,
              background: "none",
              border: `1px solid ${C.border}`,
              color: C.textMid || C.muted,
              fontSize: 14,
              fontWeight: 700,
              cursor: busy ? "default" : "pointer",
              opacity: busy ? 0.7 : 1,
            }}
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            disabled={busy}
            onClick={onConfirm}
            style={{
              flex: 1,
              padding: 14,
              borderRadius: 14,
              background: confirmBg,
              border: "none",
              color: confirmColor,
              fontSize: 14,
              fontWeight: 900,
              cursor: busy ? "default" : "pointer",
              opacity: busy ? 0.7 : 1,
            }}
          >
            {busy ? "Please wait…" : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
